import React from 'react';
import {
    Container,
} from '@mui/material';


export const PrivacyPolicy = () => {

    return (
        <Container>
            Privacy Policy
        </Container>
    );
};
